import { TableColumn } from '@vsolv/vectors/table';
import { DistributorRolesCellComponent, DistributorRolesCellProps } from './distributor-roles.component';

export class DistributorRolesColumn<I> extends TableColumn<I, DistributorRolesCellProps> {
  readonly component = DistributorRolesCellComponent;
}
